import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  opacity: 0;\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: transparent;\n  display: inline-flex;\n  align-items: center;\n  color: ", ";\n  padding-left: ", ";\n  padding-right: 8px;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  & > div {\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-right: 12px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 0;\n  pointer-events: none;\n  user-select: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  appearance: none;\n  cursor: pointer;\n  ", "\n  &[multiple] > option {\n    color: ", ";\n    background-color: ", ";\n    &:hover,\n    &:active,\n    &:checked,\n    &[selected],\n    &:focus {\n      color: ", " !important;\n      background: ", " !important;\n    }\n    padding: 8px 16px;\n  }\n  &:not([multiple]) > option {\n    &[disabled] {\n      display: none;\n    }\n  }\n  ", "\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useMemo, useRef } from 'react';
import CloseIcon from '@tourlane/iconography/Glyphs/Navigation/Close';
import DownIcon from '@tourlane/iconography/Glyphs/Navigation/DropdownDown';
import styled from 'styled-components';
import { ICON_SIZE } from '../../constants';
import SvgIcon from '../../SvgIcon';
import { ADVENTURE_GREEN, INACTIVE_GRAY, NIGHTINGALE_BLACK, SENSATION_WHITE } from '../../colors';
import FormLabel from '../../Form/FormLabel';
import { getPx } from '../../helpers/common';
import { useAutofill, useInOut, useInput } from '../../hooks';
import { INPUT_HEIGHT, INPUT_HORIZONTAL_PADDING, INPUT_TEXT_WITH_ICON_LEFT_PADDING } from '../constants';
import FormContainer from '../../Form/FormContainer/FormContainer';
import FormWrapper from '../../Form/FormWrapper/FormWrapper';
import FormField from '../../Form/FormField/FormField';
import FormIconWrapper from '../../Form/FormIconWrapper/FormIconWrapper';
import FormIconRightWrapper from '../../Form/FormIconRightWrapper/FormIconRightWrapper';
import { Input as InputSize } from '../../Typography/constants/input.size';
import { baseTextStyle } from '../../Typography/style/base';
import { convertToString, equalStrings } from '../../helpers/strings';
import { isDefined, isDefinedSelectValue } from '../../helpers/defined';
import { setRef } from '../../helpers/refs';
import { triggerChangeEvent } from '../../helpers/events-trigger';
import { userSelectNoneStyle } from '../../tokens/user-select';
import { pointerEventsNoneStyle } from '../../tokens/pointer-events';
import { baseEllipsisStyle } from '../../tokens/ellipsis';
import { getIconColor, getIconHoverColor, getInputButtonColor } from '../../helpers/icons';
import { height } from '../../style/height';
import { minHeight } from '../../style/min-height';
import { lineHeight } from '../../style/line-height';
import { fontSize } from '../../style/font-size';
import { paddingLeft } from '../../style/padding-left';
import { paddingRight } from '../../style/padding-right';
var StyledSelect = styled.select(_templateObject(), function (_ref) {
  var multiple = _ref.multiple;
  return multiple ? minHeight(INPUT_HEIGHT) : height(INPUT_HEIGHT);
}, NIGHTINGALE_BLACK, SENSATION_WHITE, SENSATION_WHITE, ADVENTURE_GREEN, function (_ref2) {
  var value = _ref2.value;
  return !value && "\n    color: " + INACTIVE_GRAY + ";\n  ";
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && "\n    cursor: not-allowed;\n  ";
});
var StyledIconRightWrapper = styled(FormIconRightWrapper)(_templateObject2());
var StyledAdditionalIconWrapper = styled(FormIconRightWrapper)(_templateObject3());
var StyledFieldText = styled.div(_templateObject4(), NIGHTINGALE_BLACK, getPx(INPUT_HORIZONTAL_PADDING), fontSize(InputSize.fontSize), lineHeight(InputSize.lineHeight), baseTextStyle, pointerEventsNoneStyle, userSelectNoneStyle, function (_ref4) {
  var withIcon = _ref4.withIcon;
  return withIcon && paddingLeft(INPUT_TEXT_WITH_ICON_LEFT_PADDING);
}, function (_ref5) {
  var withRightIcon = _ref5.withRightIcon;
  return withRightIcon && paddingRight(INPUT_TEXT_WITH_ICON_LEFT_PADDING);
}, function (_ref6) {
  var hasValue = _ref6.hasValue;
  return !hasValue && "color: " + INACTIVE_GRAY + ";";
}, baseEllipsisStyle);
var StyledField = styled(FormField)(_templateObject5(), function (_ref7) {
  var $height = _ref7.$height;
  return isDefined($height) ? height($height) : '';
}, function (_ref8) {
  var $noPadding = _ref8.$noPadding;
  return $noPadding ? "padding: 0 !important;" : '';
});

var renderOption = function renderOption(option, idx, groupIdx) {
  if (groupIdx === void 0) {
    groupIdx = -1;
  }

  return /*#__PURE__*/React.createElement("option", {
    key: "option-" + idx + "-" + groupIdx,
    value: option.value,
    disabled: option.disabled
  }, option.custom ? "" + option.custom.label + (option.custom.hint ? " (" + option.custom.hint + ")" : '') : option.label);
};

var renderOptionsList = function renderOptionsList(options, groupIdx) {
  if (options === void 0) {
    options = [];
  }

  if (groupIdx === void 0) {
    groupIdx = -1;
  }

  return options.map(function (option, idx) {
    return renderOption(option, idx, groupIdx);
  });
}; // According to: https://www.w3schools.com/tags/tag_optgroup.asp


var renderOptions = function renderOptions(options) {
  if (options === void 0) {
    options = [];
  }

  return options.map(function (option, idx) {
    return option.options ? option.label ? /*#__PURE__*/React.createElement("optgroup", {
      label: option.label,
      key: "group-" + idx
    }, renderOptionsList(option.options, idx)) : renderOptionsList(option.options, idx) : renderOption(option, idx);
  });
};

var findOption = function findOption(options, value) {
  if (options === void 0) {
    options = [];
  }

  for (var i = 0; i < options.length; i++) {
    if (options[i].options) {
      var option = findOption(options[i].options, value);

      if (option) {
        return option;
      }
    } else {
      if (equalStrings(options[i].value, value)) {
        return options[i];
      }
    }
  }
};

var _ref11 = /*#__PURE__*/React.createElement(CloseIcon, null);

var _ref12 = /*#__PURE__*/React.createElement(DownIcon, null);

var DropdownNativeSelect = /*#__PURE__*/React.forwardRef(function (_ref9, forwardedRef) {
  var _additionalIndicatorP, _additionalIndicatorP2;

  var _ref9$noPadding = _ref9.noPadding,
      noPadding = _ref9$noPadding === void 0 ? false : _ref9$noPadding,
      _ref9$noBorder = _ref9.noBorder,
      noBorder = _ref9$noBorder === void 0 ? false : _ref9$noBorder,
      _ref9$shrinkPlacehold = _ref9.shrinkPlaceholder,
      shrinkPlaceholder = _ref9$shrinkPlacehold === void 0 ? false : _ref9$shrinkPlacehold,
      _ref9$hideErrorOnFocu = _ref9.hideErrorOnFocus,
      hideErrorOnFocus = _ref9$hideErrorOnFocu === void 0 ? true : _ref9$hideErrorOnFocu,
      onBlur = _ref9.onBlur,
      onFocus = _ref9.onFocus,
      value = _ref9.value,
      defaultValue = _ref9.defaultValue,
      _onChange = _ref9.onChange,
      onValueChange = _ref9.onValueChange,
      error = _ref9.error,
      className = _ref9.className,
      _ref9$options = _ref9.options,
      options = _ref9$options === void 0 ? [] : _ref9$options,
      _ref9$disabled = _ref9.disabled,
      disabled = _ref9$disabled === void 0 ? false : _ref9$disabled,
      _ref9$notClearable = _ref9.notClearable,
      notClearable = _ref9$notClearable === void 0 ? false : _ref9$notClearable,
      _ref9$blurOnSelect = _ref9.blurOnSelect,
      blurOnSelect = _ref9$blurOnSelect === void 0 ? false : _ref9$blurOnSelect,
      icon = _ref9.icon,
      iconRight = _ref9.iconRight,
      additionalIndicator = _ref9.additionalIndicator,
      additionalIndicatorProps = _ref9.additionalIndicatorProps,
      _ref9$placeholder = _ref9.placeholder,
      placeholder = _ref9$placeholder === void 0 ? '' : _ref9$placeholder,
      _ref9$hideDropdownInd = _ref9.hideDropdownIndicator,
      hideDropdownIndicator = _ref9$hideDropdownInd === void 0 ? false : _ref9$hideDropdownInd,
      _ref9$hideClearIndica = _ref9.hideClearIndicator,
      hideClearIndicator = _ref9$hideClearIndica === void 0 ? false : _ref9$hideClearIndica,
      _ref9$multiple = _ref9.multiple,
      multiple = _ref9$multiple === void 0 ? false : _ref9$multiple,
      _ref9$height = _ref9.height,
      height = _ref9$height === void 0 ? INPUT_HEIGHT : _ref9$height,
      props = _objectWithoutPropertiesLoose(_ref9, ["noPadding", "noBorder", "shrinkPlaceholder", "hideErrorOnFocus", "onBlur", "onFocus", "value", "defaultValue", "onChange", "onValueChange", "error", "className", "options", "disabled", "notClearable", "blurOnSelect", "icon", "iconRight", "additionalIndicator", "additionalIndicatorProps", "placeholder", "hideDropdownIndicator", "hideClearIndicator", "multiple", "height"]);

  var fieldRef = useRef(null);

  var _useInput = useInput(value, defaultValue != null ? defaultValue : '', onValueChange),
      internalValue = _useInput[0],
      setInternalValue = _useInput[1];

  var _useInOut = useInOut(onFocus, onBlur),
      isFocused = _useInOut[0],
      handleFocus = _useInOut[1],
      handleBlur = _useInOut[2];

  var _useAutofill = useAutofill(),
      setAutofillRef = _useAutofill.setRef,
      isAutofilled = _useAutofill.isAutofilled;

  var showClearIcon = !notClearable && internalValue;
  var showDownIcon = !showClearIcon;
  var isAdditionalIndicatorDisabled = (_additionalIndicatorP = additionalIndicatorProps == null ? void 0 : additionalIndicatorProps.isDisabled) != null ? _additionalIndicatorP : disabled;
  var handleClear = useCallback(function () {
    triggerChangeEvent(fieldRef.current, internalValue, undefined);
  }, [fieldRef, internalValue]);
  var selectedOption = useMemo(function () {
    return findOption(options, internalValue);
  }, [options, internalValue]);
  return /*#__PURE__*/React.createElement(FormWrapper, {
    className: className,
    $error: error,
    $disabled: disabled,
    $focused: !!isFocused,
    $autofilled: isAutofilled,
    $withPrefix: props.withPrefix,
    $withSuffix: props.withSuffix,
    $noBorder: noBorder,
    $withPersistError: !hideErrorOnFocus
  }, /*#__PURE__*/React.createElement(FormContainer, null, icon && /*#__PURE__*/React.createElement(FormIconWrapper, null, /*#__PURE__*/React.createElement(SvgIcon, {
    color: getInputButtonColor(isFocused, disabled, error, !hideErrorOnFocus),
    size: ICON_SIZE
  }, icon)), /*#__PURE__*/React.createElement(StyledField, _extends({
    $height: height,
    $noPadding: noPadding,
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
    },
    onMouseUp: function onMouseUp(e) {
      e.stopPropagation();
    },
    as: StyledSelect,
    ref: function ref(_ref10) {
      setRef(forwardedRef, _ref10);
      setAutofillRef(_ref10);
      fieldRef.current = _ref10;
    },
    error: error,
    disabled: disabled,
    $withIcon: !!icon,
    $withRightIcon: showDownIcon,
    value: convertToString(internalValue, true),
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: function onChange(e) {
      var _e$target, _e$target2;

      var newValue = multiple ? [].concat((e == null ? void 0 : (_e$target = e.target) == null ? void 0 : _e$target.options) || []).filter(function (o) {
        return o.selected;
      }).map(function (o) {
        return o.value;
      }) : e == null ? void 0 : (_e$target2 = e.target) == null ? void 0 : _e$target2.value;
      _onChange == null ? void 0 : _onChange(e);
      setInternalValue(newValue);

      if (blurOnSelect) {
        fieldRef.current.blur();
      }
    },
    multiple: multiple
  }, props), renderOptions(options)), !multiple && (!shrinkPlaceholder || isFocused || isDefinedSelectValue(internalValue, multiple)) && /*#__PURE__*/React.createElement(StyledFieldText, {
    hasValue: !!selectedOption,
    withIcon: !!icon,
    withRightIcon: showDownIcon
  }, /*#__PURE__*/React.createElement("div", null, selectedOption ? selectedOption.label : shrinkPlaceholder ? '' : placeholder || ''))), additionalIndicator && !!selectedOption && /*#__PURE__*/React.createElement(StyledAdditionalIconWrapper, _extends({
    pointer: (_additionalIndicatorP2 = !(additionalIndicatorProps != null && additionalIndicatorProps.isDisabled)) != null ? _additionalIndicatorP2 : !disabled,
    disabled: isAdditionalIndicatorDisabled,
    color: getIconColor(isAdditionalIndicatorDisabled),
    colorHover: getIconHoverColor(isAdditionalIndicatorDisabled),
    size: ICON_SIZE
  }, additionalIndicatorProps), additionalIndicator), showClearIcon && !hideClearIndicator && /*#__PURE__*/React.createElement(FormIconRightWrapper, {
    pointer: !disabled,
    disabled: disabled,
    onClick: function onClick() {
      if (!disabled) {
        handleClear();
      }
    },
    color: getIconColor(disabled),
    colorHover: getIconHoverColor(disabled),
    size: ICON_SIZE
  }, _ref11), showDownIcon && !hideDropdownIndicator && /*#__PURE__*/React.createElement(StyledIconRightWrapper, {
    pointer: !disabled,
    disabled: disabled,
    color: getIconColor(disabled),
    colorHover: getIconHoverColor(disabled),
    size: ICON_SIZE
  }, iconRight || _ref12), shrinkPlaceholder && placeholder && /*#__PURE__*/React.createElement(FormLabel, {
    withIcon: !!icon,
    withRightIcon: true,
    shrink: !!(multiple || isFocused || isDefinedSelectValue(internalValue, multiple)),
    focused: !!isFocused,
    disabled: disabled,
    error: !!error,
    placeholder: placeholder
  }));
});
export default DropdownNativeSelect;